module.exports = __webpack_public_path__ + "static/img/icon-fullscreen.45a1adf0.svg";